<script>
import formatDate from '@utils/format-date'
import formatCurrency from "@utils/format-currency";
import { orderIsCanPay, orderIsOffline } from "@utils/ipetbooking-order";
import { merchantComputed, authComputed } from "@store/helpers";
import { prepaidFormatExpiredDate, prepaidFormatUsedTimes, prepaidIsExpired } from "@utils/ipetbooking-prepaid";
import { formatDepositStatusTitle } from "@utils/format-deposit";
import { conditionList } from "@utils/is-condition";


export default {
  props: {
    orderList: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  computed: {
    ...merchantComputed,
    ...authComputed,
    formatOrderList() {
      return this.orderList.map(item => {
        return {
          head: [
            {
              title: '',
              titleClass: '',
              text: formatDepositStatusTitle(item.type),
              textClass: 'fw-medium',
              class: ''
            },
            {
              title: '',
              titleClass: '',
              text: `${Math.abs(item.total)}點－${item.extraInfo.price_title}`,
              textClass: 'font-number',
              class: ''
            },
          ],
          body: [
            {
              title: '儲值/使用',
              titleClass: '',
              text: `${this.formatPoint(item.total)}點`,
              textClass: `font-number ${this.getPointClass(item.total)}`,
              class: '',
            },
            {
              title: '剩餘點數',
              titleClass: '',
              text: `${formatCurrency(item.reduce)}點`,
              textClass: `font-number`,
              class: '',
            },
            {
              title: '日期',
              titleClass: '',
              text: item.createdAt.split(' ')[0],
              textClass: 'font-number',
              class: '',
            }
          ],
          foot: [
            {
              type: 'button',
              text: '查看詳情',
              class: `flex-grow-1 ${item.type === 'withdraw' ? 'd-none' : ''}`,
              buttonClass: this.$globalIsDingBeauty ? 'isStyleSecondary isOutline3 isSmall isFull' : 'isStylePrimary isOutline3 isRadius isSmall isFull',
              onClick: () => {
                this.goToMemberItem(item);
              },
            }
          ]
        }
      })
    }
  },
  methods: {
    formatDepositStatusTitle,
    orderIsCanPay,
    prepaidIsExpired,
    prepaidFormatExpiredDate,
    prepaidFormatUsedTimes,
    formatDate,
    formatCurrency,
    formatUsedTimesText(item) {
      return item.times - item.used > 0
        ? `${prepaidFormatUsedTimes(item.times - item.used)}/${prepaidFormatUsedTimes(item.times)}`
        : '使用完畢';
    },
    orderDropdownList(item) {
      return conditionList([
        {
          text: '前往付款',
          class: '',
          onClick: () => {
            this.goToPrepaidUnpaidCheckout(item)
          },
          condition: () => {
            return !this.isOffline(item) && item.status === 2 && orderIsCanPay(item) && (item.paymentMethod === 'Credit' || item.paymentMethod === null)
          },
        },
        {
          text: '查看訂單',
          class: '',
          onClick: () => {
            this.goToMemberPrepaidItem(item)
          },
        },
        {
          text: '再次購買',
          class: '',
          onClick: () => {
            this.onClickRepurchase(item)
          },
          condition: () => {
            return this.currentMerchant.depositSetting.isEnabled
          },
        },
        {
          text: '聯繫我們',
          class: '',
          onClick: () => {
            this.openDialogContact(item.prepaid.stores)
          },
        }
      ]);
    },
    goToMemberItem(order) {
      if (!order.extraInfo.type) return
      const {order_uuid, type} = order.extraInfo
      switch(type) {
        case 'order':
          this.$router.push({
            name: 'member-reservation-item',
            params: {
              containerUuid: order_uuid
            }
          })
          break
        case 'prepaidOrder':
          this.$router.push({
            name: 'member-prepaid-item',
            params: {
              prepaidOrderId: order_uuid
            }
          })
          break
        case 'jtailsShopOrder':
          break
        case 'customize':
          break
        default:
          this.$router.push({
            name: 'member-deposit-item',
            params: {
              depositOrderId: order_uuid
            }
          })
          break
      }
    },
    goToMemberPrepaidItemApplicable(order) {
      this.$router.push({
        name: 'member-prepaid-item',
        params: {
          prepaidOrderId: order.id
        },
        query: {
          activeTab: 'applicable'
        }
      })
    },
    goToPrepaidUnpaidCheckout(order) {
      this.$router.push({
        name: 'prepaid-unpaid-checkout',
        params: {
          storeType: order.stores[0].storeType,
          prepaidAlias: order.prepaid.alias,
          orderId: order.id
        }
      })
    },
    goToPrepaidItem(order) {
      this.$router.push({
        name: 'prepaid-item',
        params: {
          prepaidAlias: order.prepaid.groupAlias,
        }
      })
    },
    openDialogContact(storeList) {
      this.$globalDialog('DialogContact', {
        storeList
      });
    },
    isOffline(orderItem) {
      return orderIsOffline({
        order: orderItem,
        ordertype: 'order',
        type: 'prepaid',
        isList: true
      });
    },
    onClickRepurchase(orderItem) {
      if (orderItem.prepaid.state) {
        if(this.isBlock) {
          this.$globalDialog('DialogBlock', {})
          return
        }
        const loadingMaskCheckOutCart = this.$loading({
          lock: true,
          text: '正在前往結帳',
          spinner: `fal fa-circle-notch fa-spin`,
          background: 'rgba(81, 176, 202, 0.3)',
          customClass: 'isStyleCheckout'
        });

        const prepaidAlias = orderItem.prepaid.alias;

        this.tryToStoreCart({ prepaidAlias })
          .then(() => {
            const goToPrepaidCheckout = () => {
              this.$router.push({
                name: 'prepaid-checkout',
                params: {
                  prepaidAlias
                }
              });
            };

            goToPrepaidCheckout()
          })
          .catch((e) => {
            if(e.status === 'STATUS_CODE_UNDEFINED') {
              this.$globalDialog('DialogBlock', {})
            }
          })
          .finally(() => {
            loadingMaskCheckOutCart.close()
          })
      } else {
        this.openDialogRepurchase(orderItem.stores)
      }
    },
    async tryToStoreCart({ prepaidAlias }) {
      await this.$store.dispatch('cart/storeCart', {
        prepaidAlias,
      })
        .then(() => {
          return true
        })
    },
    openDialogRepurchase(storeList) {
      this.$globalDialog('DialogRepurchase', {
        storeList
      });
    },
    formatPoint(point) {
      return point > 0 ? `+${formatCurrency(point)}` : (point < 0 ? `${formatCurrency(point)}` : 0)
    },
    getPointClass(point) {
      return point > 0 ? `isPositive` : (point < 0 ? `isNegative` : '')
    },
    tableRowClassName(row) {
      const {type} = row.row.extraInfo
      if (type === 'jtailsShopOrder') return 'isRowDefault'
    }
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.depositListHistoryList">
    <BaseOrderList
      :loading="$isLoading('fetchDepositHistory')"
      loading-text="取得儲值訂單中..."
      :order-list="formatOrderList"
      class="d-xl-none"
    />
    <el-table
      v-loading="$isLoading('fetchDepositHistory')"
      element-loading-text="取得儲值訂單中..."
      :data="orderList"
      class="isStyleBase isRowPointer mb-5 d-none d-xl-block"
      :class="[$style.prepaidList, { 'isStyleDingBeauty': $globalIsDingBeauty }]"
      :row-class-name="tableRowClassName"
      @row-click="goToMemberItem"
    >
      <el-table-column v-slot="{ row }" label="日期" width="200">
        <span class="font-number">{{ row.createdAt.split(' ')[0] }}</span>
      </el-table-column>
      <el-table-column v-slot="{ row }" label="項目">
        <div class="fw-medium">{{ formatDepositStatusTitle(row.type) }}</div>
        <div v-if="row.extraInfo.type === 'order'">{{ `${Math.abs(row.total)}點－預約服務#${row.extraInfo.display_order_id}` }}</div>
        <div v-else>{{ `${Math.abs(row.total)}點－${row.extraInfo.price_title}` }}</div>
      </el-table-column>
      <el-table-column v-slot="{ row }" label="儲值/使用" width="150">
        <span class="font-number" :class="getPointClass(row.total)">{{ formatPoint(row.total) }}點</span>
      </el-table-column>
      <el-table-column v-slot="{ row }" label="剩餘點數" width="150">
        <span class="font-number">{{ formatCurrency(row.reduce) }}點</span>
      </el-table-column>
    </el-table>
    <BasePre>orderList: {{ orderList }}</BasePre>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.depositListHistoryList {
  min-height: 532px;

  :global {
    .depositListHistoryList {
      @include unstyled;

      
    }
    .orderNumber {
      letter-spacing: 1.44px;
      color: $color-primary;
      font-size: .75rem;
    }
    .isPositive {
      color: #12C494;
    }
    .isNegative {
      color: #F25555;
    }
  }
}

.prepaidList {
  :global {
    .prepaidList {
      &__title {
        font-weight: 500;
      }

      &__date {
        font-size: 0.75rem;
        color: $color-gray-2;
        letter-spacing: 0.1em;
      }
    }
  }
}
</style>
